import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import LevelBase from '../scenes/LevelBase';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Treasure extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {LevelBase} scene 
   */
  constructor(scene, end) {
    super(scene);

    this.scene = scene;

    this.isEnd = end;

    this.chest = null;
    this.gold = null;
    this.title = null;
    this.glow = null;
    this.emitter = null;
    this.tents = null;

    this.button = null;

    this.coins = [];
    this.coinRef = ['SingleCoin', '2Coins', 'CoinStk1', 'CoinStk2'];

    this.setup();
  }

  setup () {
    if (!this.isEnd) this.createEmitter();
    this.createTreasure();
  }

  createTreasure () {
    if (this.isEnd) {
      this.tents = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height, UIAssetKeys._chestTentacles, this.scene).setOrigin(0.5, 0);

      this.chest = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height, UIAssetKeys._chestClosed, this.scene).setOrigin(0.5, 0);

      this.button = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2 + 300, this.scene.scale.height / 2 + 150, UIAssetKeys._SurfaceBtn, this).setScale(0);

      this.raiseTreasure();
    }
    else {
      this.chest = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._ProgBar_Chest, this).setOrigin(0.5, 1);
    }
  }

  raiseTreasure () {
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._great_job_you_found_the_treasure, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    ABCyaPhaser.Tweens.addTween(this.tents, 1500, { y: this.scene.scale.height - 210 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.chest, 1500, { y: this.scene.scale.height - 252 }, Phaser.Math.Easing.Back.Out, () => {
      this.openTreasure();
    });
  }

  openTreasure () {
    this.chest.destroy();

    this.chest = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height - 320, UIAssetKeys._chestOpen, this.scene).setOrigin(0.5, 0);

    this.glow = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height - 205, UIAssetKeys._7_Level_4_Lvl4_TreasureGlow, this.scene).setOrigin(0.5, 1)
      .setScale(0);

    this.title = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height - 200, UIAssetKeys._7_Level_4_Lvl4_TreasureGrtJob, this.scene).setScale(0);

    this.createEmitter();

    this.gold = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height - 218, UIAssetKeys._7_Level_4_Lvl4_TreasurePile, this.scene);

    ABCyaPhaser.Tweens.addTween(this.button, 1500, { scale: 1 }, Phaser.Math.Easing.Back.Out, () => {
      this.enableButton();
    });

    ABCyaPhaser.Tweens.addTween(this.glow, 1500, { scale: 1 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.title, 1500, { y: this.scene.scale.height - 350, scale: 1, delay: 250 }, Phaser.Math.Easing.Back.Out);
    ABCyaPhaser.Tweens.addTween(this.title, 1500, { scale: 1 }, Phaser.Math.Easing.Back.Out);

    this.burst();
  }

  createEmitter () {
    this.emitterManager = this.scene.add.particles(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._ProgBar_LgCoin);
    this.emitter = this.emitterManager.createEmitter({
      maxParticles: 100,
      lifespan: 1000,
      on: false
    });

    if (this.isEnd) {
      this.emitter.setPosition(this.scene.scale.width / 2, this.scene.scale.height - 220);

      this.emitter.setSpeedX({ min: -400, max: 400 });
      this.emitter.setSpeedY({ min: -500,max: -100 });
    }
    else {
      this.add(this.emitterManager);
      this.emitterManager.y = -30;

      this.emitter.setSpeedX({ min: -200, max: 200 });
      this.emitter.setSpeedY({ min: -400,max: -100 });
    }

    this.emitter.setGravityY(500);
  }

  burst () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._Collecting_Money, this.scene);

    this.emitter.setAlpha({ start: 1, end: 0.3 });
    this.emitter.setScaleX({ start: this.isEnd ? 2 : 1, end: this.isEnd ? 1 : .1 });
    this.emitter.setScaleY({ start: this.isEnd ? 2 : 1, end: this.isEnd ? 1 : .1 });

    if (this.isEnd) {
      this.emitter.start();
    }
    else {
      this.emitter.explode(40);
      this.createCoin();
    }
  }

  createCoin () {
    const randCoin = Phaser.Math.Between(0, this.coinRef.length - 1);
    const randX = Phaser.Math.Between(-this.chest.width / 2 + 10, this.chest.width / 2 - 10);

    const coin = ABCyaPhaser.Images.addImage(randX, -30, `ProgBar_${this.coinRef[randCoin]}`, this).setOrigin(0.5, 1);
    this.coins.push(coin);

    ABCyaPhaser.Tweens.addTween(coin, 500, { y: this.chest.y - 10 }, Phaser.Math.Easing.Bounce.Out);
  }

  enableButton () {
    this.button.setInteractive({ useHandCursor: true });
    this.button.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.toSurface, this);
  }

  toSurface () {
    this.button.disableInteractive();

    this.emitterManager.destroy();
    this.chest.destroy();
    this.glow.destroy();
    this.gold.destroy();
    this.title.destroy();

    this.chest = ABCyaPhaser.Images.addImage(this.scene.scale.width / 2, this.scene.scale.height - 252, UIAssetKeys._chestClosed, this.scene).setOrigin(0.5, 0);

    this.scene.sub.grabTreasure();

    ABCyaPhaser.Tweens.addTween(this.button, 1500, { scale: 0 }, Phaser.Math.Easing.Back.In);
  }

  releaseTreasure () {
    ABCyaPhaser.Tweens.addTween(this.chest, 2000, { y: -this.chest.height }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween(this.tents, 2000, { y: this.scene.scale.height }, Phaser.Math.Easing.Linear);
  }

  cleanUp () {
    for (let l = 0; l < this.coins.length; l++) {
      this.coins[l].destroy();
    }

    this.emitterManager.destroy();
    this.chest.destroy();

    if (this.isEnd) {
      this.glow.destroy();
      this.gold.destroy();
      this.title.destroy();
    }

    this.kelpTweens = [];
  }
}